import React from 'react';
import {entity as mailingLabelSnippets} from '../../ducks/mailingLabelSnippets';
import SnippetList from './SnippetList';
import MailingLabelSnippetEditor from './MailingLabelSnippetEditor';
import {tags} from "../../ducks";
import {withSnippetFunctions} from "./snippetUtils";
import {compose} from "redux";
import {withRouter} from "react-router";
import withFiltering from "../../hocs/withFiltering";
import duckify from "../../utils/duckify";
import withTagging from "../../hocs/withTagging";

const MailingLabelSnippetList = (props) => {
    return <SnippetList
      displayName="Label"
      editModal={MailingLabelSnippetEditor}
      type="mailing_label"
      {...props}
    />;
};

const mapDucksToProps = () => ({
  items: mailingLabelSnippets,
  tags,
});

export default compose(
  withRouter,
  withFiltering,
  withTagging(mailingLabelSnippets),
  withSnippetFunctions(mailingLabelSnippets),
  duckify(mapDucksToProps)
)(MailingLabelSnippetList);
